import type { IInspection, IInspectionForm, IJobAssociatedAssetUpdate } from '@/interfaces'
import { JobForm } from '../jobs'
import { AssetType, JobType } from '@/enum'

class InspectionForm extends JobForm implements IInspectionForm {
  asset: IJobAssociatedAssetUpdate
  constructor(inspection?: IInspection) {
    super(inspection)
    this.type = JobType.INSPECTION
    this.asset = {
      type: inspection?.asset?.assetType as AssetType,
      id:
        inspection?.asset?.assetType == AssetType.VEHICLE
          ? inspection?.asset?.vehicleId
          : inspection?.asset?.assetType == AssetType.MACHINE
            ? inspection?.asset?.machineId
            : (inspection?.asset?.equipmentId as string),
      vehicle: inspection?.asset?.vehicle,
      equipment: inspection?.asset?.equipment,
      machine: inspection?.asset?.machine
    }
  }
}

export default InspectionForm
